"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelPackageEnrollmentSchema = exports.enrollPackageSchema = exports.ipPackageCoverageReasonEnum = void 0;
const zod_1 = require("zod");
/** IP package billing contracts — ADR-085 Phase 4. */
exports.ipPackageCoverageReasonEnum = zod_1.z.enum([
    'INCLUDED_IN_PACKAGE',
    'PACKAGE_LIMIT_AVAILABLE',
    'PACKAGE_LIMIT_EXHAUSTED',
    'EXCLUDED_SERVICE',
    'PREAUTH_REQUIRED',
    'CORPORATE_OVERRIDE',
    'MANUAL_PACKAGE_OVERRIDE',
    'NO_ACTIVE_PACKAGE',
    'REVERSAL',
]);
exports.enrollPackageSchema = zod_1.z.object({
    packageId: zod_1.z.string().uuid(),
    startDate: zod_1.z.coerce.date().optional(),
    endDate: zod_1.z.coerce.date().optional(),
    /**
     * Integer paise. Omit to default to the package's own base price — what the
     * patient actually paid for it. `null` is reserved for genuinely uncapped
     * itemised packages and must therefore be EXPLICIT, never accidental.
     */
    financialLimit: zod_1.z.number().int().nonnegative().nullish(),
    clinicalLimit: zod_1.z.number().int().positive().nullish(),
    approvalReference: zod_1.z.string().max(100).optional(),
    payerId: zod_1.z.string().uuid().optional(),
    isCorporate: zod_1.z.boolean().default(false),
    isCghs: zod_1.z.boolean().default(false),
    /** Coverage precedence when several packages are active. Lower first. */
    priority: zod_1.z.number().int().nonnegative().default(0),
});
exports.cancelPackageEnrollmentSchema = zod_1.z.object({
    reason: zod_1.z.string().min(1).max(1000),
});
//# sourceMappingURL=ip-package.schema.js.map